import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const Outline_Offset = () => {
  return (
    <div className="tutorial-container">
      {/* Title */}
      <h1 className="tutorial-title">📐 CSS Outline Offset</h1>

      {/* Intro */}
      <p className="tutorial-intro">
        The <code>outline-offset</code> property adds space between an element’s
        outline and its border. This helps improve visibility or create
        decorative effects.
      </p>

      {/* Syntax */}
      <div className="tutorial-section">
        <h2 className="section-title">Syntax</h2>
        <CodeCopyBlock
          code={`selector {
  outline-offset: length;
}`}
        />
        <p>
          - <strong>length</strong>: distance between the outline and border
          (e.g., <code>5px</code>, <code>1em</code>, <code>-2px</code>) <br />-
          Default value: <code>0</code> (no gap between border and outline)
        </p>
      </div>

      {/* Examples */}
      <div className="tutorial-section">
        <h2 className="section-title">Examples</h2>
        <CodeCopyBlock
          code={`div.one {
  outline: 3px solid red;
  outline-offset: 0px;
}

div.two {
  outline: 3px solid blue;
  outline-offset: 5px;
}

div.three {
  outline: 3px solid green;
  outline-offset: 10px;
}

div.negative {
  outline: 3px solid purple;
  outline-offset: -5px;
}`}
        />

        {/* Live Demos */}
        <div
          style={{
            border: "2px solid #333",
            outline: "3px solid red",
            outlineOffset: "0px",
            padding: "10px",
            marginBottom: "15px",
          }}
        >
          Offset = 0px (default)
        </div>
        <div
          style={{
            border: "2px solid #333",
            outline: "3px solid blue",
            outlineOffset: "5px",
            padding: "10px",
            marginBottom: "15px",
          }}
        >
          Offset = 5px
        </div>
        <div
          style={{
            border: "2px solid #333",
            outline: "3px solid green",
            outlineOffset: "10px",
            padding: "10px",
            marginBottom: "15px",
          }}
        >
          Offset = 10px
        </div>
        <div
          style={{
            border: "2px solid #333",
            outline: "3px solid purple",
            outlineOffset: "-5px",
            padding: "10px",
            marginBottom: "15px",
          }}
        >
          Offset = -5px (overlaps border)
        </div>
      </div>

      {/* Description */}
      <div className="tutorial-section">
        <h2 className="section-title">Important Notes</h2>
        <ul className="tutorial-list">
          <li>Positive values push the outline away from the element.</li>
          <li>
            Negative values move the outline closer, overlapping the border.
          </li>
          <li>
            Outline offset is great for focus indicators and accessibility
            design.
          </li>
        </ul>
      </div>

      {/* Next Steps */}
      <div className="tutorial-section">
        <h2 className="section-title">Next Steps</h2>
        <p>
          Now that you know about <strong>outline-offset</strong>, try combining
          it with{" "}
          <a href="/css/outline-shorthand" className="learn-more">
            Outline Shorthand
          </a>{" "}
          for creative and accessible designs.
        </p>
      </div>
    </div>
  );
};

export default Outline_Offset;
